<div [hidden]="!active" class="flex-row">
  <ng-content></ng-content>
</div>
